import "../style/VisionMission.css";
import { FaLightbulb, FaBullseye, FaFlag } from "react-icons/fa";
import VisionHead from "./images/Our_Vision_Head.png";

function VisionMission() {
    const bulletIconSize = 16;

    return (
        <>
            <div
                className="vision-hero"
                style={{
                    backgroundImage: `linear-gradient(90deg, rgba(12, 12, 16, 0.7) 0%, rgba(12, 12, 16, 0.45) 55%, rgba(12, 12, 16, 0.2) 100%), url(${VisionHead})`,
                }}
            >
                <div
                    className="vision-hero__inner"
                >
                    <div
                        style={{
                            fontSize: "clamp(1.9rem, 3.2vw, 2.7rem)",
                            fontWeight: 300,
                            lineHeight: 1.1,
                            marginBottom: "12px",
                            textShadow: "0 6px 22px rgba(0,0,0,0.4)",
                        }}
                    >
                        Der Grund für Medway
                    </div>
                    <div
                        style={{
                            fontSize: "0.9rem",
                            color: "#d8d9e5",
                            textShadow: "0 6px 18px rgba(0,0,0,0.4)",
                        }}
                    >
                        Was uns wichtig ist bei Medway
                    </div>
                </div>
            </div>

            {/* Vision-Mission cards */}
            <div style={{ backgroundColor: "#f7f9fc", padding: "70px 0" }}>
                <div
                    className="vision-card"
                >
                    <div style={{ textAlign: "center" }}>
                        <div style={{ letterSpacing: "3px", color: "#111D4B", fontWeight: 700, marginBottom: "12px" }}>
                            MEDWAY VON
                        </div>
                        <h2 style={{ color: "#111D4B", fontSize: "2.4rem", marginBottom: "10px" }}>
                            Vision zur Mission
                        </h2>
                        <div
                            style={{
                                width: "420px",
                                maxWidth: "100%",
                                height: "3px",
                                backgroundColor: "#111D4B",
                                margin: "0 auto 22px",
                                borderRadius: "999px",
                            }}
                        />
                        <p style={{ color: "#4a4a4a", fontSize: "1.05rem", lineHeight: 1.7, marginBottom: "46px" }}>
                            Hier stellen wir Ihnen unsere Mission und Vision vor.
                            <br />
                            Dafür steht Medway.
                        </p>
                    </div>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                            gap: "36px",
                            alignItems: "stretch",
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "18px",
                                boxShadow: "0 18px 40px rgba(0,0,0,0.12)",
                                padding: "34px 32px",
                                textAlign: "left",
                                border: "1px solid #eef1f7",
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "center", marginBottom: "26px" }}>
                                <FaLightbulb size={74} color="#111D4B" />
                            </div>
                            <h3 style={{ color: "#111D4B", fontSize: "1.6rem", textAlign: "center", marginBottom: "18px" }}>
                                Unsere Vision
                            </h3>
                            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: "14px" }}>
                                {[
                                    "Wir verfolgen das Ziel, eine führende Rolle in der Vermittlung von Fachkräften im Gesundheitswesen einzunehmen.",
                                    "Durch moderne Konzepte und fundierte Branchenkenntnisse unterstützen wir Einrichtungen dabei, qualifizierte und engagierte Talente zu gewinnen.",
                                    "Wir bauen vertrauensvolle und nachhaltige Beziehungen zwischen Arbeitgebern und Fachkräften auf, die auf langfristige Zusammenarbeit ausgerichtet sind.",
                                    "Mit der gezielten Vermittlung kompetenter Fachkräfte tragen wir zur Entlastung des Gesundheitssystems bei.",
                                    "Unser Anspruch ist es, aktiv zur Qualität und Zukunftsfähigkeit der medizinischen Versorgung beizutragen.",
                                ].map((item) => (
                                    <li key={item} style={{ display: "flex", gap: "12px", color: "#4a4a4a", lineHeight: 1.6 }}>
                                        <FaLightbulb
                                            size={bulletIconSize}
                                            color="#111D4B"
                                            style={{ marginTop: "4px", width: bulletIconSize, height: bulletIconSize, flex: `0 0 ${bulletIconSize}px` }}
                                        />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "18px",
                                boxShadow: "0 18px 40px rgba(0,0,0,0.12)",
                                padding: "34px 32px",
                                textAlign: "left",
                                border: "1px solid #eef1f7",
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "center", marginBottom: "26px" }}>
                                <FaBullseye size={74} color="#111D4B" />
                            </div>
                            <h3 style={{ color: "#111D4B", fontSize: "1.6rem", textAlign: "center", marginBottom: "18px" }}>
                                Unsere Mission
                            </h3>
                            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: "14px" }}>
                                {[
                                    "Wir fuehren persoenliche Briefings durch, um ein tiefes Verstaendnis Ihrer Unternehmenskultur zu erlangen.",
                                    "Unser intensiver Beratungsansatz gewaehrleistet hoechste Vertraulichkeit.",
                                    "Wir streben nach partnerschaftlicher Zusammenarbeit und bieten umfassende Marktanalysen.",
                                    "Wir liefern offenes Feedback zur Besetzbarkeit Ihrer Positionen und begleiten den Prozess eng.",
                                ].map((item) => (
                                    <li key={item} style={{ display: "flex", gap: "12px", color: "#4a4a4a", lineHeight: 1.6 }}>
                                        <FaFlag
                                            size={bulletIconSize}
                                            color="#111D4B"
                                            style={{ marginTop: "4px", width: bulletIconSize, height: bulletIconSize, flex: `0 0 ${bulletIconSize}px` }}
                                        />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default VisionMission;
